import React from 'react';
import UserInfo from './UserInfo';
import RequestQuoteStatus from './RequestQuoteStatus';
import WXPayWidget from './WXPay';

const Account: React.FC = () => {
  return (
    <div className="account-root">
      <h2 className="account-title">Account</h2>
      
      <div className="widgets-container">
        <div className="widget">
          <h3 className="widget-title">Private Node Request</h3>
          <RequestQuoteStatus />
        </div>

        <div className="widget">
          <h3 className="widget-title">WX Pay</h3>
          <WXPayWidget />
        </div>
      </div>

      <div className="user-info-container">
        <UserInfo />
      </div>
    </div>
  );
};

export default Account;